export interface GetLendAndReturnConditionRequest {
  branchCode: string
  lendType: string
  userType: string
}

export function GetLendAndReturnConditionRequestToJSON(
  value: GetLendAndReturnConditionRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    lend_type: value.lendType !== '' ? value.lendType : undefined,
    user_type: value.userType !== '' ? value.userType : undefined
  }
}
